import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { usersEndpoint } from "../constants";

const UserPermissions = () => {
  const { id } = useParams();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [role, setRole] = useState("");

  const token = localStorage.getItem('token');

  useEffect(() => {
    const fetchUser = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${usersEndpoint}${id}/`, {
          headers: {
            'Authorization': `Token ${token}`,
          },
        });
        setUser(response.data);
        setRole(response.data.role);
      } catch (err) {
        setError("Failed to load user data.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    if (token && id) {
      fetchUser();
    }
  }, [token, id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      await axios.patch(`${usersEndpoint}${id}/`, { role: role }, {
        headers: {
          'Authorization': `Token ${token}`,
        },
      });
      alert("User role updated successfully!");
    } catch (err) {
      setError("Failed to update user role.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="text-center py-8">Loading...</div>;
  }

  if (error) {
    return <div className="text-center py-8 text-red-500">Error: {error}</div>;
  }

  if (!user) {
    return <div className="text-center py-8">No user data available.</div>;
  }

  return (
    <div className="p-8">
      <h1 className="text-2xl font-semibold text-gray-900">Manage Permissions for {user.username}</h1>
      <form onSubmit={handleSubmit} className="mt-6">
        <div className="mb-4">
          <label htmlFor="role" className="block text-sm font-medium text-gray-700">User Role</label>
          <select
            id="role"
            value={role}
            onChange={(e) => setRole(e.target.value)}
            className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
          >
            <option value="client">Client</option>
            <option value="recruiter">Recruiter</option>
            <option value="candidate">Candidate</option>
          </select>
        </div>
        <button
          type="submit"
          className="px-4 py-2 text-white bg-[#19bfb7] rounded-lg hover:bg-[#18ada6]"
        >
          Save Changes
        </button>
      </form>
    </div>
  );
};

export default UserPermissions;
